module.exports = __webpack_public_path__ + "static/media/dl-back-example.82c16dca.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/dl-back-example.svg
// module id = 205
// module chunks = 0